import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from 'src/@/components/ui/dialog';
import { Button } from 'src/@/components/ui/button';
import Iconify from 'src/components/Iconify';

// Dialog unico pros dois fluxos de exclusao em massa: selecao manual
// (count = qtd marcada) e "Excluir todos" filtrado por conta (accountName
// presente). O check "remover do Facebook" e' best-effort e generico aqui —
// ao contrario do delete unico (MktPostDeleteDialog), nao da' pra saber de
// antemao quais dos N posts tem external_ids.facebook, entao o texto avisa
// que so se aplica aos que ja foram publicados la.
export default function MktPostsBulkDeleteDialog({ open, count, accountName, onClose, onConfirm, deleting }) {
    const { t } = useTranslation('marketing');
    const [remote, setRemote] = useState(true);
    const isAccountMode = Boolean(accountName);

    return (
        <Dialog open={open} onOpenChange={(v) => { if (!v) onClose(); }}>
            <DialogContent className="sm:max-w-[440px] rounded-2xl border-0 shadow-2xl bg-white p-0 overflow-hidden">
                <div className="p-6 pb-4 border-b border-gray-100 bg-red-50/50">
                    <DialogHeader>
                        <DialogTitle className="text-xl font-semibold text-gray-900 flex items-center gap-2">
                            <Iconify icon="mdi:alert-circle-outline" width={24} height={24} className="text-red-500" />
                            {isAccountMode ? t('posts.bulkDelete.titleAccount') : t('posts.bulkDelete.title')}
                        </DialogTitle>
                    </DialogHeader>
                </div>

                <div className="p-6">
                    <p className="text-gray-600 text-sm">
                        {isAccountMode
                            ? t('posts.bulkDelete.confirmAccount', { name: accountName })
                            : t('posts.bulkDelete.confirm', { count })}
                    </p>

                    <div className="mt-3 bg-amber-50 border border-amber-200 rounded-xl p-3 text-xs text-amber-800">
                        {t('posts.bulkDelete.facebookNote')}
                    </div>

                    <label className="flex items-center gap-2 mt-3 text-sm text-gray-700 cursor-pointer select-none">
                        <input
                            type="checkbox"
                            className="w-4 h-4 text-[#7C3AED] border-gray-300 rounded"
                            checked={remote}
                            onChange={(e) => setRemote(e.target.checked)}
                        />
                        {t('posts.bulkDelete.alsoFromFacebook')}
                    </label>

                    <p className="text-xs text-gray-400 mt-3">{t('posts.delete.warning')}</p>
                </div>

                <div className="flex justify-end gap-3 p-6 pt-2 border-t border-gray-100 bg-gray-50/30">
                    <Button
                        variant="ghost"
                        onClick={onClose}
                        disabled={deleting}
                        className="rounded-xl text-gray-500 hover:text-gray-900 hover:bg-gray-100"
                    >
                        {t('common.cancel')}
                    </Button>
                    <Button
                        onClick={() => onConfirm({ remote })}
                        disabled={deleting}
                        className="bg-red-500 hover:bg-red-600 text-white rounded-xl shadow-sm px-6"
                    >
                        {deleting ? (
                            <div className="flex items-center gap-2">
                                <div className="animate-spin rounded-full h-4 w-4 border-2 border-white/20 border-t-white" />
                                {t('common.deleting')}
                            </div>
                        ) : (
                            isAccountMode ? t('posts.bulkDelete.deleteAllAction') : t('posts.bulkDelete.deleteSelectedAction', { count })
                        )}
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
}
